import { MenuItem } from '@mui/material';
import styled from 'styled-components';

import { IWorkflowStep, StepTypeEnum, TStep } from '@modules/admin/AdminTools/Workflows/types';
import { LocalTabContent } from '@styles/CommonStyles';
import { extraColor } from '@styles/muiTheme';

type WrapperType = {
  stepData: IWorkflowStep;
  isChecked: boolean;
};

export const getStylesByType = (type: TStep) => `
  font-weight: 600;
  &:before {
    content: '';
    left: 0;
    top: 0;
    width: 3px;
    height: 100%;
    position: absolute;
    background-color: ${getColorByType(type)};
    border-radius: 4px 0px 0px 4px;
  }
`;

export const getColorByType = (type: TStep) => {
  switch (type) {
    case StepTypeEnum.Fork:
      return '#68A12F';
    case StepTypeEnum.ReRoute:
      return '#3C8DBC';
    case StepTypeEnum.ReRouteAll:
      return '#E26943';
  }
};

export const DotsWrapper = styled.div`
  position: absolute;
  top: 27px;
  transform: translateY(-50%);
  right: 7px;
  cursor: pointer;
  pointer-events: auto;
`;

export const Wrapper = styled.div<WrapperType>(
  ({ stepData, isChecked }) => `
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 12px 36px 12px 17px;
  border: 1px solid  ${isChecked ? 'transparent' : '#C3C3C3'};
  border-radius: 4px;
  font-weight: ${stepData.isTextBold ? '600' : '400'};
  cursor: pointer;
  background-color: ${isChecked ? '#A6CDE3' : stepData.isDefault ? '#F4F4F4' : '#fff'};
  ${stepData.stepType !== 'Step' ? getStylesByType(stepData.stepType) : ''};
}`,
);

export const RouteDetailsBlock = styled.div<{ type: TStep }>(
  ({ type }) => `
   margin-top: 5px;
   font-size: 14px;
   letter-spacing: 0.16px;
   font-weight: 400;
   padding-left: 6px;
   display: flex;
   & svg {
    top: -4px;
    transform: rotate(-180deg);
    fill: ${getColorByType(type)};
    margin-right: 5px;
   }
`,
);

export const StyledMenuItem = styled(MenuItem)`
  font-weight: 600;
  letter-spacing: 0.16px;
  padding: 3px 12px;
  text-align: left;
  font-size: 17px;
  letter-spacing: 0.16px;

  &:hover {
    cursor: pointer;
    background-color: ${extraColor.palette.grey.light};
  }
`;

export const PageContent = styled(LocalTabContent)`
  height: auto;
  min-height: 300px;
  width: 100%;
  padding-bottom: 60px;
`;

export const AddButton = styled.div`
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.75;
  padding: 6px 16px;
  border-radius: 4px;
  font-weight: 700;
  background-color: rgb(54, 132, 176);
  width: 143px !important;
  color: #fff;
  &:hover {
    text-decoration: none;
    background-color: rgb(5, 61, 93);
    box-shadow:
      rgba(0, 0, 0, 0.2) 0px 2px 4px -1px,
      rgba(0, 0, 0, 0.14) 0px 4px 5px 0px,
      rgba(0, 0, 0, 0.12) 0px 1px 10px 0px;
  }
`;

export const ReasonsGridWrapper = styled.div`
  height: 287px;
  margin-bottom: 20px;
  .reasons-grid {
    .MuiDataGrid-cell,
    .MuiDataGrid-row,
    .MuiDataGrid-columnHeaders,
    .MuiDataGrid-columnHeader {
      max-height: none !important;
    }
    .MuiDataGrid-cell--editing {
      padding: 10px 10px;
    }
    .MuiDataGrid-cell.MuiDataGrid-cell--editing input {
      border-bottom: none !important;
    }
  }
`;

export const WorkflowLevelWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-width: 360px;
  max-width: 360px;
  display: flex;
  gap: 15px 0;
  flex-direction: column;
  align-items: flex-start;
`;

export const Header = styled.div`
  width: 100%;
  padding-left: 16px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  background-color: #e6e6e6;
  letter-spacing: 0.16px;
  color: #161616;
  opacity: 1;
`;

export const WorkflowLevelBlockWrapper = styled.div`
  position: absolute;
  overflow: auto;
  width: auto;
  display: flex;
  height: 100%;
  gap: 20px;
`;